module.exports = __webpack_public_path__ + "img/A5CD8F.1374fe57.svg";